const config = {
    websocket: {
      url: 'wss://backend.flatlinker.com:443',
      urlL: 'ws://localhost:3001',
      reconnectDelayStart: 0,
      reconnectDelayEnd: 5000,
      reconnectStep: 500
    },
    googleMap: {
      apiKey: "AIzaSyAvJpeGudwpEI1lXkuFjoqa0FzDWmpkOyE",
      id: "87fece659462f2f7"
    },
    gallery: {
      normal: {
        maxWidth: 1024,
        maxHeight: 1024,
        maxSize: 512
      },
      icon: {
        maxWidth: 256,
        maxHeight: 256,
        maxSize: 64
      }
    },
    photos: {
      places: "https://flatlinker-photos.s3.eu-west-1.amazonaws.com/"
    },
    stateColors: {
      placeNew: "state-new",
      placeInPreparation: "state-in-preparation",
      placePublished: "state-published"
    }
  };
  
  export default config;